import React from 'react';
import { bool, func, number, oneOf, string } from 'prop-types';
import ClassNames from 'classnames';

import Icon from '../icon/Icon';

import './StepItem.scss';

const getSizeClassName = size => {
  const sizeClassNames = {
    small: 'Step-item_size_small',
    large: 'Step-item_size_large'
  };

  return sizeClassNames[size];
};

const getStatusData = (status, data) => {
  const statusData = {
    completed: {
      className: 'Step-item_status_completed',
      icon: <Icon className="Step-item__icon" icon="check" />,
      text: 'Completed'
    },
    in_progress: {
      className: 'Step-item_status_in_progress',
      text: 'In progress'
    },
    with_issues: {
      className: 'Step-item_status_with_issues',
      icon: <Icon className="Step-item__icon" icon="times" />,
      text: 'With issues'
    },
    skipped: {
      className: 'Step-item_status_skipped',
      icon: <Icon className="Step-item__icon" icon="times" />,
      text: 'Skipped'
    }
  };

  return statusData[status] && statusData[status][data];
};

const StepItem = ({
  selected,
  className,
  label,
  onClick,
  size,
  status,
  number: stepNumber
}) => (
  <button
    aria-selected={selected}
    className={ClassNames(
      'Step-item',
      getSizeClassName(size),
      getStatusData(status, 'className'),
      className
    )}
    onClick={onClick}
    role="tab"
    type="button"
  >
    <div className="Step-item__icon-container">
      {getStatusData(status, 'icon') || (
        <span className="Step-item__icon">{stepNumber}</span>
      )}
    </div>
    <div className="Step-item__text">
      <span className="Step-item__status">{getStatusData(status, 'text')}</span>
      <span className="Step-item__label">{label}</span>
    </div>
  </button>
);

StepItem.propTypes = {
  className: string,
  label: string,
  onClick: func,
  selected: bool,
  size: oneOf(['small', 'large']),
  status: oneOf([
    'default',
    'completed',
    'in_progress',
    'with_issues',
    'skipped'
  ]),
  number: number.isRequired
};

StepItem.defaultProps = {
  className: '',
  label: '',
  onClick: () => {},
  selected: false,
  size: undefined,
  status: 'default'
};

export default StepItem;
